import Axios from 'api/axios'
import { type CardPartner, SpendControlApiFactory } from 'api/swagger/definitions/backoffice'
import config from 'config'

const spendControlApi = SpendControlApiFactory(undefined, config.boBaseUrl, Axios)

export const getRules = () => spendControlApi.getSpendControlRulesV1().then(({ data }) => data)
export const getRule = (ruleId: string) => spendControlApi.getSpendControlRuleV1(ruleId).then(({ data }) => data)
export const getCategories = (cardPartner: string) =>
  spendControlApi.getAllSpendControlCategoriesV1(cardPartner as CardPartner).then(({ data }) => data)
